import React, { useEffect } from 'react'
import Navbar from '../HomePage/Navbar'
import Services from './Service'
import FeaturesSection from './FeaturesSection'
import BenefitsSection from '../HomePage/BenefitsSection'
import AboutQuote from './AboutQuote'
import TrustedSection from './TrustedSection'
import ContactSection from '../HomePage/ContactSection'
import NewsLetter from '../HomePage/NewsLetter'
import Footer from '../HomePage/Footer'

function ServiceIndex() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div> 
      <Navbar />
      <Services />
      <FeaturesSection />
      <BenefitsSection />
      <TrustedSection />
      <AboutQuote />
      <ContactSection />
      <NewsLetter />
      <Footer />
    </div>
  )
}

export default ServiceIndex
